import React, { useContext, useState } from 'react';
import styles from './styles.module.scss';
import ForgetPasswordMobile from '../ForgetPasswordMobile';
import ForgetPasswordCode from '../ForgetPasswordCode';
import ForgetPasswordSuccess from '../ForgetPasswordSuccess';
import loginLogo from '../../../../assets/imgs/login/loginLogo.svg';
import { AdminContext } from '../../context/AdminContext';

const ForgetPassword = ({ setLoginModal, setForgetPasswordModal }) => {
  const [newuser, setNewUser] = useState({ mobile: '', code: '', countryCode:'98' });
  const [level1, setLevel1] = useState(true);
  const [level2, setLevel2] = useState(false);
  const [level3, setLevel3] = useState(false);
  const { content, themeMode, isElectron } = useContext(AdminContext);
  const goToLoginFunction = () => {
    setLoginModal();
    setLevel1(true);
    setLevel2(false);
    setLevel3(false);
  };
  console.log("newuser", newuser)

  return (
    // <div
    //   className={`flex flex-row justify-start items-stretch w-full h-auto pb-4 pt-4`}
    // >
    //   <div
    //     className={`flex flex-col justify-start items-start w-auto h-auto border-l-2 ${styles.containerPadding}`}
    //   >
    <div
      className={`loginBackground ${
        isElectron && 'loginBackgroundPadding'
      } relative`}
    >
      <div className={`flex flex-col justify-center items-center  m-auto`}>
        <img
          src={loginLogo}
          width={100}
          height={100}
          className={`makeWhite ${styles.extraMargin}`}
        />
        <p className={`${styles.extraMargin} ${'textWhite'}`}>
          {content?.name}
        </p>
        <div
          className={`flex justify-center items-stretch w-full h-auto py-6 ${styles.flexStyle} loginContent`}
        >
          <div className={`${styles.formContainer}`}>
            {level1 == true && (
              <ForgetPasswordMobile
                setLevel1={setLevel1}
                setLevel2={setLevel2}
                newuser={newuser}
                setNewUser={setNewUser}
                setLoginModal={setLoginModal}
              />
            )}
            {level2 == true && (
              <ForgetPasswordCode
                setLevel2={setLevel2}
                setLevel3={setLevel3}
                newuser={newuser}
              />
            )}
            {level3 == true && (
              <ForgetPasswordSuccess
                setLevel2={setLevel2}
                setLevel3={setLevel3}
                setLoginModal={setLoginModal}
                setForgetPasswordModal={setForgetPasswordModal}
              />
            )}
          </div>
        </div>

        {!level3 && (
          <div
            className={`flex flex-row justify-center items-center w-auto h-auto ${styles.bottomTexts}`}
          >
            <p>{content?.haveAccount?.title}</p>
            <p>
              <span
                className={`cursor-pointer linkStyleNoColor`}
                onClick={goToLoginFunction}
              >
                {' '}
                {content?.haveAccount?.button}
              </span>
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default ForgetPassword;
